<script setup lang="ts">
import Skeleton from "primevue/skeleton";
</script>

<template>
  <div class="flex flex-col gap-10">
    <div
      v-for="i in 3"
      :key="i"
    >
      <Skeleton
        height="2rem"
        width="20rem"
      />
      <Skeleton
        class="mt-6"
        height="1rem"
      />
      <Skeleton
        class="mt-4"
        height="1rem"
      />
    </div>
  </div>
</template>
